"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Button_1 = require("./Button");
var KeyboardShortcut_1 = require("./KeyboardShortcut");
var utils_1 = require("./utils");
var getPaddingStyle = function (size) {
    switch (size) {
        case "xsmall":
            return "6px 8px";
        case "small":
            return "10px 8px";
        case "medium":
            return "14px 12px";
        case "large":
        default:
            return "16px 12px";
    }
};
/**
 * Wrapper around the Button component that allows rendering a keyboard shortcut icon.
 * On mobile, it functions as a regular Button without the shortcut.
 */
var KeyboardButton = function (_a) {
    var shortcut = _a.shortcut, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, className = _a.className, props = __rest(_a, ["shortcut", "variant", "size", "className"]);
    var paddingStyle = getPaddingStyle(size);
    var isMobile = (0, utils_1.useIsMobile)();
    if (isMobile || !shortcut)
        return (react_1.default.createElement(Button_1.Button, __assign({ variant: variant, size: size, className: className }, props)));
    return (react_1.default.createElement(Button_1.Button, __assign({ variant: variant, size: size, padding: paddingStyle, className: className }, props),
        react_1.default.createElement(FlexRow, null,
            props.children,
            react_1.default.createElement(KeyboardShortcut_1.KeyboardShortcut, __assign({ shortcut: shortcut, variant: variant }, props)))));
};
exports.KeyboardButton = KeyboardButton;
var FlexRow = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n"])));
var templateObject_1;
